import { useToast as useVueToast } from 'vue-toastification'

export function useToast() {
  const toast = useVueToast()
  
  return {
    success: (message, options = {}) => {
      return toast.success(message, {
        position: 'top-right',
        timeout: 3000,
        ...options
      })
    },
    
    error: (message, options = {}) => {
      return toast.error(message, {
        position: 'top-right',
        timeout: 5000,
        ...options
      })
    },
    
    warning: (message, options = {}) => {
      return toast.warning(message, {
        position: 'top-right',
        timeout: 4000,
        ...options
      })
    },
    
    info: (message, options = {}) => {
      return toast.info(message, {
        position: 'top-right',
        timeout: 3000,
        ...options
      })
    },
    
    // Generic toast method
    toast: (message, options = {}) => {
      return toast(message, {
        position: 'top-right',
        timeout: 3000,
        ...options
      })
    }
  }
}